import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../../hooks/useLanguage';

import Heart from '../../../../../svg/heart.svg';
import TextUa from '../../../../../svg/heart_ua.svg';
import TextRu from '../../../../../svg/heart_ru.svg';

const HomeAboutHeader = ({ aboutData }) => {
  const langToggle = useLanguage;
  const roundedText = langToggle(
    <TextUa className="home-about__header-icon__text" />,
    <TextRu className="home-about__header-icon__text" />
  );
  return (
    <header className="home-about__header">
      <div className="home-about__header-info">
        <span className="home-about__header-info__marker">
          {langToggle('Про нас', 'О нас')}
        </span>
        <h2 className="home-about__header-info__title">
          {langToggle(aboutData.title_ua, aboutData.title_ru)}
        </h2>
      </div>
      <div
        className="home-about__header-icon"
        data-scroll=""
        data-scroll-speed="1"
        data-scroll-delay="0.03"
      >
        {roundedText}
        <Heart className="home-about__header-icon__heart" />
      </div>
    </header>
  );
};

HomeAboutHeader.propTypes = {
  aboutData: PropTypes.object,
};

export default HomeAboutHeader;
